exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-cancel[data-v-b3a6836e]{font-size:14px;cursor:pointer;width:20px;height:20px;border:1px solid #ddd;border-radius:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.btn-cancel[data-v-b3a6836e]:hover{background-color:#a0a0a0;color:#fff}.btn-match[data-v-b3a6836e]{font-size:12px!important;height:28px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);

// exports
